import {
  Breadcrumb,
  Row,
  Col,
  Button,
  Form,
  Input,
  Spin,
  Progress,
} from "antd";
import "../../accountList/AccountListPage.css"

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { modalConfirmCancel, modalCustom } from "../../modal/modalCustom";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { SIDEBAR_CONSTANT } from "../../../constant/sidebar.constant";
import { RESOURCE_LIST_CONSTANT } from "../../../constant/resourcelist.constant";
import { IoCloudUploadOutline } from "react-icons/io5";
import { AiFillDelete } from "react-icons/ai";
import { useDropzone } from 'react-dropzone';
import isEmpty from "lodash/isEmpty";
import { convertFileSizePreview, getRandomInt } from "../../../function/functions";
import uploadService from "../../../service/uploadService";
import resourceListService from "../../../service/resourceListService";
import moment from "moment";
import { ROUTER_CONSTANT } from "../../../constant/router.constant";

const ResourceListEditForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = useSelector((state) => state.loginData.token);
  const baseUrl = ROUTER_CONSTANT.HOME + ROUTER_CONSTANT.RESOURCE_LIST;
  const [form] = Form.useForm();
  const [editPageResources, setEditPageResources] = useState(true);

  const [dataResource, setDataResource] = useState(
    {
      resource_list_id: location?.state?.resource_list_id,
      resource_id: location?.state?.resource_id,
      resource_name: location?.state?.resource_name,
      description: location?.state?.description,
      logo: location?.state?.logo,
    }
  );

  const [fileList, setFileList] = useState([]);
  const [progressValue, setProgressValue] = useState(0);
  const [activeSpin, setActiveSpin] = useState(false);
  const [intervalId, setIntervalId] = useState(null);

  const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/jpg': ['.png', '.jpg', '.jpeg',],
    },
    maxFiles: 1,
    maxSize: 2000000,
  });

  const okFunction = () => {
    navigate(`${baseUrl}`);
  }

  const failedFunction = () => {
    // TODO : Keep It for future use, click button after pop up failed modal
  }

  const handleChange = (event) => {
    let fieldName = event.target.name;
    let fieldValue = event.target.value;
    setDataResource({ ...dataResource, [fieldName]: fieldValue });
  }

  const checkFormFieldChange = () => {
    if (
      form.getFieldValue("resource_id") === location.state.resource_id &&
      form.getFieldValue("resource_name") === location.state.resource_name &&
      form.getFieldValue("description") === location.state.description &&
      form.getFieldValue("logo") === location.state.logo
    ) {
      return true;
    }
    return false;
  }

  const handleConfirmCancel = () => {
    if (checkFormFieldChange()) {
      return okFunction();
    }

    modalConfirmCancel(
      RESOURCE_LIST_CONSTANT.MODAL_CANCEL_TITLE,
      RESOURCE_LIST_CONSTANT.MODAL_CANCEL_CONTENT,
      RESOURCE_LIST_CONSTANT.MODAL_CANCEL_OK_TEXT,
      RESOURCE_LIST_CONSTANT.MODAL_CANCEL_NO_TEXT,
      okFunction
    );
  }

  const handleSave = () => {
    setActiveSpin(true);
    if (!dataResource.logo) {
      uploadService.uploadFile(fileList[0])
        .then((response) => {
          setDataResource({ ...dataResource, logo: response.data.additionalEntity.result.path });
          form.setFieldsValue({ logo: response.data.additionalEntity.result.path });
          setActiveSpin(false);
          form.submit();
        })
        .catch((error) => {
          form.setFieldsValue({ logo: null });
          setActiveSpin(false);
          form.submit();
        })
    } else {
      setActiveSpin(false);
      form.submit();
    }
  }

  const handleSubmitSuccess = () => {
    setActiveSpin(true);
    resourceListService.editResource(token, dataResource)
      .then((response) => {
        setActiveSpin(false);
        if (response.data.nexsoft.payload.status.success) {
          handleSuccessAddResource();
        } else {
          handleFailedAddResourceWithMessage(response.data.nexsoft.payload.status.message);
        }
      })
      .catch((error) => {
        handleFailedAddResource();
        setActiveSpin(false);
      })
  }

  const handleSuccessAddResource = () => {
    modalCustom(
      RESOURCE_LIST_CONSTANT.MODAL_SUCCESS_TITLE_ADD_RESOURCES,
      RESOURCE_LIST_CONSTANT.MODAL_SUCCESS_CONTENT_EDIT_RESOURCES,
      RESOURCE_LIST_CONSTANT.MODAL_SUCCESS_OK_BUTTON_ADD_RESOURCES,
      okFunction,
      "success"
    )
  }

  const handleFailedAddResourceWithMessage = (failedMessage) => {
    modalCustom(
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_TITLE_ADD_RESOURCES,
      failedMessage,
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_OK_BUTTON_ADD_RESOURCES,
      failedFunction,
      "failed"
    )
  }

  const handleFailedAddResource = () => {
    modalCustom(
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_TITLE_ADD_RESOURCES,
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_CONTENT_EDIT_RESOURCES,
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_OK_BUTTON_ADD_RESOURCES,
      failedFunction,
      "failed"
    )
  }

  const handleRemoveUploadLogo = () => {
    setFileList([]);
    setProgressValue(0);
    clearInterval(intervalId);
    form.setFieldsValue({
      logo: null
    });
    setDataResource({
      ...dataResource,
      logo: null
    })
  }

  const templateUploadLogo = () => {
    return (
      <>
        <div className="form-upload-logo-header-container">
          {dataResource.logo &&
            <>
              <Row className="form-upload-logo-success-style" align="middle">
                <Col xs={24} md={12}>
                  <img
                    alt="Upload Logo"
                    className="add-resource-logo-list-style"
                    src={dataResource.logo}
                  />
                </Col>

                <Col xs={24} md={12} style={{ textAlign: "right" }}>
                  <AiFillDelete
                    style={{ color: "red", cursor: "pointer" }}
                    onClick={() => handleRemoveUploadLogo()}
                  />
                </Col>
              </Row>
            </>
          }

          {!dataResource.logo &&
            <>
              {isEmpty(fileList) || progressValue < 100 ?
                <div className="form-upload-logo-style">
                  <div {...getRootProps({ className: 'dropzone' })}>
                    <input {...getInputProps()} />
                    <IoCloudUploadOutline className="form-upload-logo-icon" />
                    <br />
                    {progressValue === 0 &&
                      <>
                        <span>
                          {RESOURCE_LIST_CONSTANT.PLACEHOLDER_UPLOAD_LOGO_CLICK}
                        </span>
                        {RESOURCE_LIST_CONSTANT.PLACEHOLDER_UPLOAD_LOGO_DRAGDROP}
                      </>
                    }
                  </div>
                  {progressValue !== 0 &&
                    <>
                      <Row justify="space-between">
                        Uploading...
                        <div onClick={() => handleRemoveUploadLogo()}>X</div>
                      </Row>
                      <Progress percent={progressValue} />
                    </>
                  }
                </div>
                :
                <Row className="form-upload-logo-success-style" align="middle">
                  <Col xs={24} md={6}>
                    <img
                      alt="Upload Logo"
                      className="add-resource-logo-list-style"
                      src={URL.createObjectURL(fileList[0])}
                    />
                  </Col>

                  <Col xs={24} md={12} style={{ textAlign: "center" }}>
                    {`${fileList[0].path} (${convertFileSizePreview(fileList[0].size)})`}
                  </Col>

                  <Col xs={24} md={6} style={{ textAlign: "right" }}>
                    <AiFillDelete
                      style={{ color: "red", cursor: "pointer" }}
                      onClick={() => handleRemoveUploadLogo()}
                    />
                  </Col>
                </Row>
              }
            </>
          }

        </div>
      </>
    )
  }

  const setIntervalTime = (file, fileDividedPart) => {
    let intervalTime = 500 / fileDividedPart;
    if (file[0].size >= 500000 && file[0].size < 1000000) {
      intervalTime = 1000 / fileDividedPart;
    }
    if (file[0].size >= 1000000) {
      intervalTime = 1500 / fileDividedPart;
    }

    return intervalTime;
  }

  useEffect(() => {
    const checkValidationFile = () => {
      if (fileRejections.length > 0) {
        form.setFieldsValue({
          logo: null
        });
        form.setFields([
          {
            name: 'logo',
            errors: [RESOURCE_LIST_CONSTANT.VALIDATION_LOGO_REQUIRED],
          },
        ]);
        setFileList([]);
      }

      if (acceptedFiles.length > 0) {
        let maxProgressValue = 100;
        let dividedPart = getRandomInt(10);
        let segment = maxProgressValue / dividedPart;
        let currentProgressValue = 0;
        let interval = setIntervalTime(acceptedFiles, dividedPart);

        let intervalIdFunction = setInterval(() => {
          currentProgressValue += segment
          setProgressValue(Math.floor(currentProgressValue))
          if (currentProgressValue > maxProgressValue) {
            setFileList(acceptedFiles);
            setProgressValue(100);
            form.setFields([
              {
                name: 'logo',
                errors: null,
              },
            ]);
            clearInterval(intervalIdFunction);
          }
        }, interval);
        setIntervalId(intervalIdFunction);
      }
    }

    if (!location.state) {
      navigate(baseUrl);
    }

    setEditPageResources(true);
    if (location.state) {
      const dataResourceList = location.state;
      form.setFieldsValue({
        resource_id: dataResourceList.resource_id,
        resource_name: dataResourceList.resource_name,
        description: dataResourceList.description,
        logo: dataResourceList.logo,
        resource_list_id: dataResourceList.resource_list_id,
        created_by: dataResourceList.created_by,
        created_client: dataResourceList.created_client,
        created_at: moment.utc(dataResourceList.created_at).format("YYYY-MM-DD HH:mm:ss"),
        updated_client: dataResourceList.updated_client,
        updated_at: moment.utc(dataResourceList.updated_at).format("YYYY-MM-DD HH:mm:ss"),
        deleted: dataResourceList.deleted,
      });
    }
    checkValidationFile();
  }, [form, acceptedFiles, fileRejections, location.state, navigate, baseUrl]);

  return (
    <>
      <Row>
        <Breadcrumb separator=">">
          <Breadcrumb.Item>{SIDEBAR_CONSTANT.MENU_SETTING_LIST}</Breadcrumb.Item>
          <Breadcrumb.Item
            onClick={() => handleConfirmCancel()}
            style={{ cursor: "pointer" }}
          >
            {RESOURCE_LIST_CONSTANT.MENU_RESOURCE_LIST}
          </Breadcrumb.Item>
          <Breadcrumb.Item>{RESOURCE_LIST_CONSTANT.TITLE_RESOURCE_LIST_EDIT}</Breadcrumb.Item>
        </Breadcrumb>
      </Row>

      <Row className="accountlist-title">
        <MdOutlineArrowBackIosNew
          onClick={() => handleConfirmCancel()}
          className="arrow-back-form-title" />
        {RESOURCE_LIST_CONSTANT.TITLE_RESOURCE_LIST_EDIT}
      </Row>

      <br />

      <Form
        form={form}
        layout="vertical"
        onFinish={() => handleSubmitSuccess()}
      >

        <Row className="card-white-box-container">
          <Col xs={24} md={24}>
            <div className="card-white-box">
              <Row justify="space-between">

                <Col xs={24} md={12}>
                  <Row>
                    <Col xs={24} md={23}>
                      <Form.Item name="resource_list_id" label="Resource List ID">
                        <Input name="resource_list_id" disabled={editPageResources} />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={24} md={23}>
                      <Form.Item
                        name="resource_id"
                        label="Resource ID"
                        rules={[
                          {
                            required: true,
                            message: RESOURCE_LIST_CONSTANT.VALIDATION_RESOURCE_ID_REQUIRED,
                            pattern: new RegExp(/^[a-z][a-z0-9]+$/),
                            validateTrigger: "onSubmit",
                          },
                        ]}
                      >
                        <Input
                          placeholder={RESOURCE_LIST_CONSTANT.PLACEHOLDER_RESOURCE_ID}
                          name="resource_id"
                          onChange={(event) => handleChange(event)}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={24} md={23}>
                      <Form.Item
                        name="resource_name"
                        label="Resource Name"
                        rules={[{
                          required: true,
                          message: RESOURCE_LIST_CONSTANT.VALIDATION_RESOURCE_NAME_REQUIRED,
                          validateTrigger: "onSubmit",
                        }]}
                      >
                        <Input
                          placeholder={RESOURCE_LIST_CONSTANT.PLACEHOLDER_RESOURCE_NAME}
                          name="resource_name"
                          onChange={(event) => handleChange(event)}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={24} md={23}>
                      <Form.Item
                        name="description"
                        label={
                          <div>
                            Description
                            <span className="form-label-optional"> (Optional) </span>
                          </div>
                        }
                      >
                        <Input
                          name="description"
                          onChange={(event) => handleChange(event)}
                          placeholder={RESOURCE_LIST_CONSTANT.PLACEHOLDER_DESCRIPTION} />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={24} md={23}>
                      <Form.Item
                        name="logo"
                        label="Upload Logo"
                        rules={[{
                          required: true,
                          message: RESOURCE_LIST_CONSTANT.VALIDATION_LOGO_REQUIRED,
                          validateTrigger: "onSubmit",
                        }]}
                      >
                        {templateUploadLogo()}
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

                <Col xs={24} md={12}>
                  <Row>
                    <Col xs={24} md={23}>
                      <Form.Item name="created_by" label="Created By">
                        <Input name="created_by" disabled={editPageResources} />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={24} md={23}>
                      <Form.Item name="created_client" label="Created Client">
                        <Input name="created_client"
                          disabled={editPageResources} />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={24} md={23}>
                      <Form.Item name="created_at" label="Created At">
                        <Input
                          name="created_at" disabled={editPageResources} />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={24} md={23}>
                      <Form.Item name="updated_client" label="Updated Client">
                        <Input
                          name="updated_client"
                          disabled={editPageResources} />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={24} md={23}>
                      <Form.Item name="updated_at" label="Updated At">
                        <Input
                          name="updated_at"
                          disabled={editPageResources}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={24} md={23}>
                      <Form.Item name="deleted" label="Deleted">
                        <Input name="deleted" disabled={editPageResources} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>

              </Row>
            </div>
          </Col>
        </Row>

        <Row justify="end">
          <Col>
            <Form.Item>
              <Button className="form-button-footer-style" key="cancel"
                onClick={() => handleConfirmCancel()}
              >
                Cancel
              </Button>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item shouldUpdate>
              {() => (
                <Spin spinning={activeSpin}>
                  <Button className="form-button-footer-style" key="save"
                    onClick={() => handleSave()}
                    type="primary">
                    Save
                  </Button>
                </Spin>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  )
}

export default ResourceListEditForm;